import React, {Component} from 'react';
import {scroller} from "react-scroll";
import $ from 'jquery';
import {AJAX, close_popup, show_popup, hidePreloader, showPreloader} from "../functions";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {gTagClickEventValue, showLoadingPayment, hideLoadingPayment} from "./frontend_script";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import valid from "card-validator";

class PaymentPage extends Component {
	constructor(props) {
		super(props);
		this.onProceed = this.onProceed.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.onBlurHandler = this.onBlurHandler.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onPayment = this.onPayment.bind(this);
		this.onCancelPayment = this.onCancelPayment.bind(this);
		this.addTimeBooking = this.addTimeBooking.bind(this);
		this.onCheckPayment = this.onCheckPayment.bind(this);
		this.goHomePage = this.goHomePage.bind(this);

		this.state = {
			pressProceed: false,
			go_home_show: false,
			card_numberError: 'This field is required.',
			card_numberDirty: false,
			expiry_monthError: 'This field is required.',
			expiry_monthDirty: false,
			expiry_yearError: 'This field is required.',
			expiry_yearDirty: false,
			security_codeError: 'This field is required.',
			security_codeDirty: false,
			customer_fnameError: 'This field is required.',
			customer_fnameDirty: false,
			customer_lnameError: 'This field is required.',
			customer_lnameDirty: false,
//			titleError: 'This field is required.',
//			titleDirty: false,
//			countryError: 'This field is required.',
//			countryDirty: false,
			validate: false,
			ref_id: '',
			total: '',
			hire: '',
			name: '',
			windcave_session_id: '',
			first_check: false,
			card_data: {},
			windcave_3dsecure_link: '',
			end_time: 0,
			duration: 0
		};
	}

	componentWillUnmount() {
		this.stop_3dSecure();
	}

	setEnd_3dSecure() {
		this.setState({end_time: (moment().valueOf() + 1860000)}); // a half of hour
		setTimeout(()=>this.start_3dSecure(), 1000);
	}

	start_3dSecure() {
		if (this.state.end_time > 0) {
			let startTime = moment().valueOf();
			let duration = this.state.end_time - startTime;
			this.setState({duration: duration});
			if (duration <= 0) {
				this.stop_3dSecure();
				return false;
			}
			setTimeout(() => this.start_3dSecure(), 1000);
		}
	}

	stop_3dSecure() {
		this.setState({end_time: 0, duration: 0});
	}

	onBlurHandler(e) {
		let name = e.target.name + 'Dirty';
		this.setState({[name]: true});
	}

	onChange(e) {
		let nameError = e.target.name + 'Error';
		if (e.target.value.length > 0) {
			this.setState({[nameError]: ''});
		}
		else {
			this.setState({[nameError]: 'This field is required.'});
		}
	}

	addTimeBooking() {
		let newEndBooking = moment(window.localStorage.getItem('end_create_booking'), "DD-MM-YYYY hh:mm:ss A").add(2, 'minutes').format("DD-MM-YYYY hh:mm:ss A");
		window.localStorage.setItem('end_create_booking', newEndBooking);
	}

	onProceed(e) {
		let booking_form_data = this.props.booking_form_data;
		let fields = this.props.booking_field_list.payment; // validate need all fields
		let fields_send = this.props.booking_field_list.payment_send; // send need card holder name only
		let btn = e.target;
		let form_inputs = $(btn).closest('.card-data');
		let card_data = {}; // card info for send on windcave
		let params = {};
		let t = this;

		let validate = true;
		let toSet = {};

		Object.keys(fields_send).map((item) => {
			let el = form_inputs.find('[name='+fields_send[item]+']');
			if (el.length) {
				if (fields_send[item] == 'card_number') {
					booking_form_data.payment[fields_send[item]] = el[0].value.trim().replace(/\s+/g, '').slice(-4);
					params['payment[' + fields_send[item] + ']'] = el[0].value.trim().replace(/\s+/g, '').slice(-4);
				}
				else {
					booking_form_data.payment[fields_send[item]] = el[0].value.trim();
					params['payment[' + fields_send[item] + ']'] = el[0].value.trim();
				}
			}
		});

		Object.keys(fields).map((item) => {
			if (this.state[fields[item] + 'Error'] !== '') {
				toSet[fields[item] + 'Dirty'] = true;
				validate = false;
			}
			// save card data
			let el = form_inputs.find('[name='+fields[item]+']');
			if (el.length) {
				if (['card_number', 'security_code', 'expiry_month', 'expiry_year'].includes(fields[item]))
					card_data[fields[item]] = el[0].value.replace(/\s+/g, '');
				else
					card_data[fields[item]] = el[0].value.trim();
			}
		});

		const numberValidation = valid.number(card_data['card_number']);
		if (
			card_data['card_number'].length < 13 ||
			card_data['card_number'].length > 19 ||
			!numberValidation.isValid
		) {
			toSet['card_numberError'] = 'Incorrect card number';
			toSet['card_numberDirty'] = true;
			validate = false;
		}

		const cvvValidation = valid.cvv(card_data['security_code']);
		if (!cvvValidation.isValid) {
			toSet['security_codeError'] = 'Incorrect security code';
			toSet['security_codeDirty'] = true;
			validate = false;
		}

		const expiryValidation = valid.expirationDate({
			month: card_data['expiry_month'],
			year: card_data['expiry_year']
		});
		if (!expiryValidation.isValid) {
			toSet['expiry_monthError'] = 'Incorrect expiry month';
			toSet['expiry_monthDirty'] = true;
			validate = false;
		}

		toSet['card_data'] = card_data;
		toSet.validate = validate;
		this.setState(toSet);

		if (validate) {
			this.addTimeBooking();

			const gaCookie = document.cookie.split('; ').find(row => row.startsWith('_ga='));
			if (gaCookie) {
				const gaValue = gaCookie.split('=')[1];
				const decodedValue = decodeURIComponent(gaValue);
				params.ga_client_id = decodedValue.split('.').slice(2, 4).join('.'); // Extract client ID part
			}

			params.action = 'api/booking/payment';
			params.signature_json = this.props.booking_form_data.signature_json;
			params.signature_png = this.props.booking_form_data.signature_png;
			params.vehicle_name = this.props.booking_form_data.vehicle_name;
			params.submit = this.props.booking_form_data.submit;
			params.donation_count = this.props.booking_form_data.donation_count;

			Object.keys(booking_form_data.driver_license_images).map((k) => {
				params['driver_license_images[' + k + ']'] = booking_form_data.driver_license_images[k];
			});

			Object.keys(booking_form_data.booking).map((k) => {
				params['booking[' + k + ']'] = booking_form_data.booking[k];
			});

			Object.keys(booking_form_data.additional_drivers).map((k) => {
				let driver_item = [];
				Object.keys(booking_form_data.additional_drivers[k]).map((kk) => {
					driver_item[kk] = booking_form_data.additional_drivers[k][kk];
				});
				params['booking[' + k + '][]'] = driver_item;
			});

			// todo использовать одинаковые названия полей в поиске и здесь
			if (this.props.booking_form_data.booking.hire == 'local') {
				params['booking[pickup_location]'] = this.props.booking_form_data.booking.pickuplocationid;
				params['booking[return_location]'] = this.props.booking_form_data.booking.dropofflocationid;
			}

//			console.log('params', params, booking_form_data);
			t.setState({pressProceed: true});

			AJAX(bm_ajax_url, 'POST', params, {
				response_json: true,
				func_waiting: function () {
					showPreloader();
				},
				func_callback: function (resp) {
					if (!resp.error && resp.ajax_link) {

						t.setState({ref_id: resp.ref_id, total: resp.total, hire: resp.hire, name: resp.name, windcave_session_id: resp.windcave_session_id});

						let params_payment = {
							card: {
								cardHolderName: t.state.card_data['customer_fname'] + ' ' + t.state.card_data['customer_lname'],
								cardNumber: t.state.card_data['card_number'].replace(/\s+/g, ''),
								dateExpiryMonth: t.state.card_data['expiry_month'],
								dateExpiryYear: t.state.card_data['expiry_year'],
								cvc2: t.state.card_data['security_code'].replace(/\s+/g, '')
							}
						};

//						navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent('Ajax link: '+JSON.stringify(resp.ajax_link))+'&origin='+bf_debug_telegram_original);
//						navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent('Ajax send data: '+JSON.stringify(params_payment))+'&origin='+bf_debug_telegram_original);

						$.ajax({
							url: resp.ajax_link,
							headers: {'Content-Type':'application/json'},
							type: 'POST',
							data: JSON.stringify(params_payment),
							cache: false,
							dataType: 'json',
							success: function (response, status, jqXHR) {

//								navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent('Ajax link response: '+JSON.stringify(response))+'&origin='+bf_debug_telegram_original);

//								console.log(response, status);
								if (response['links'][0]['href'] !== undefined && response['links'][0]['href'] != "") {
									t.setState({windcave_3dsecure_link: response['links'][0]['href']});
									t.setEnd_3dSecure();

									hidePreloader();

									window.localStorage.removeItem('start_create_booking');
									window.localStorage.removeItem('end_create_booking');

									if (typeof window.stopBooking === 'function')
										window.stopBooking();

									let content =
										<div className="row">
											<div className="col-12 text-center" style={{paddingRight: "0", paddingLeft: "0"}}>
												<div className="row m-3">
													<div className="col-12 text-center gray" style={{padding: "0"}}>
														<iframe id={'windcave_3dsecure_iframe'} style={{border: "none"}}
																src={response['links'][0]['href']}></iframe>
													</div>
												</div>
											</div>
										</div>;
									show_popup(content, {auto_close: false});

									//if device width < 420px, we calculate indent for center alignment
									if (window.innerWidth < 420) {
										let windcave_3dsecure_iframe_width = ((420 - window.innerWidth) / 2) + 3;
										document.getElementById('windcave_3dsecure_iframe').style.marginLeft = '-' + windcave_3dsecure_iframe_width + 'px';
									}

									setTimeout(t.onCheckPayment, 10000, false); // check payment after 30 seconds
								}
								else {
// moved down temporarily			showPopupWithGoBack('<div>Your booking could not be made with the supplied information. <br/>Please contact the office at <a href="tel:1300826883">1300 826 883</a> to arrange this booking.</div>');
									t.setState({go_home_show: true});

									let windcave_session_id = '';
									if (resp.windcave_session_id !== undefined)
										windcave_session_id = resp.windcave_session_id;

									AJAX(
										bm_ajax_url,
										'POST',
										{action: 'api/booking/payment_windcave_failed', windcave_session_id: windcave_session_id, status: jqXHR.status, statusText: jqXHR.statusText, responseText: jqXHR.responseText, success: 'empty link'},
										{
											response_json: true,
											func_callback: function (response_failed) {
												//console.log(response_failed);
												if (response_failed.reCo !== undefined && response_failed.reCo == "AQ")
													showPopupWithGoBack('<div>Sorry, but we are temporarily unable to accept AMEX cards online. <br/>Please call <a href="tel:1300826883">1300 826 883</a> to handle this purchase.</div>');
												else
													showPopupWithGoBack('<div>Your booking could not be made with the supplied information. <br/>Please contact the office at <a href="tel:1300826883">1300 826 883</a> to arrange this booking.</div>');
											}
										});
									t.setState({pressProceed: false});

									if (bf_debug_telegram_original != 'test')
										navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message='+encodeURIComponent('Response 3DSecure link: '+JSON.stringify(response))+'&origin='+bf_debug_telegram_original);
								}
								hidePreloader();
							},
							error: function (jqXHR, status, errorThrown) {

								if (typeof Bugsnag !== 'undefined' && Bugsnag.notify) {
									var error = new Error('error: ' + status);
									Bugsnag.notify(error);
								}

								//console.log(jqXHR, status, errorThrown);
								showPopupWithGoBack('<div>There was an error taking payment with this card. <br/>Please double check the entered details and try again. <br/>If you still have problems, call the office at <a href="tel:1300826883">1300 826 883</a>.</div>');
								t.setState({go_home_show: true});

								let windcave_session_id = '';
								if (resp.windcave_session_id !== undefined)
									windcave_session_id = resp.windcave_session_id;

								AJAX(
									bm_ajax_url,
									'POST',
									{action: 'api/booking/payment_windcave_failed', windcave_session_id: windcave_session_id, status: jqXHR.status, statusText: jqXHR.statusText, responseText: jqXHR.responseText},
									{
										response_json: true,
										func_callback: function (response_failed) {
											//console.log(response_failed);
										}
									});

								if (bf_debug_telegram_original != 'test') {
									let responseText = jqXHR.responseText;
									if (responseText != undefined)
										responseText = responseText.substring(0, 500);
									navigator.sendBeacon('/wp-content/plugins/booking-form/bf_notify.php?message=' + encodeURIComponent('Error response 3DSecure link, Status: ' + jqXHR.status + ' Status Text: ' + jqXHR.statusText + ' Response Text: ' + responseText) + '&origin=' + bf_debug_telegram_original);
								}

								t.setState({pressProceed: false});
								hidePreloader();
							}
						})
					} else {
						let message = '';

						if (resp.error == 'bad files') {
							t.props.handleSetSomeBlock('reset_photo_fields', true);
							t.props.handleSetSomeBlock('donate_show', false);
							t.props.handleSetSomeBlock('payment_show', false);
						} else {
							t.setState({pressProceed: false});

							if (resp.error) {
								if (resp.fields !== undefined && resp.fields.length) {
									for (let i = 0; i < resp.fields.length; i++) {
										let field = resp.fields[i];

										if (field.name === 'additional_drivers_count') {
											message += ' Check additional driver\'s data';
										} else {
//											$('input[name="' + field.name + '"]').val('');
											message += (' ' + field.error);
										}
									}
									t.props.handleSetSomeBlock('donate_show', false);
									t.props.handleSetSomeBlock('payment_show', false);
								}

								if (message) {
									showPopupWithGoBack('Incorrect submitted form details. Please check, and try again. ' + message);
								} else {
									if (resp.error === 1) {
										if (resp.message === 'Allowance not calculated') {
											showPopupWithGoBack('Distance cannot be calculated. Please try later or call to us.');
										} else if (resp.message === 'Car not found') {
											showPopupWithGoBack('The car is already booked, please choose another time.');
										} else if (resp.message === 'did not find reservationref' || resp.message === 'empty order id') {
											showPopupWithGoBack('<div class="text-center"><b>ERROR CREATING BOOKING.</b><br/>Please contact Go With The Gecko on <a href="tel:1300826883">1300 826 883</a>, let them know you’ve been charged, and they can finalise your booking for you.<br/>Sorry for the inconvenience.</div>');
										} else {
											showPopupWithGoBack('Session invalid, please try again');
										}
									} else {
										t.setState({go_home_show: true});
										showPopupWithGoBack('<div class="text-center">Sorry! It looks like we have encountered an error securing your reservation. No payment has been taken, but also your reservation hasn’t been made.<br/>Please call our office at <a href="tel:1300826883">1300 826 883</a>, and will get your hire vehicle arranged for you immediately. Thank you.</div>');
									}
								}
							}
						}
						hidePreloader();
					}

					t.props.handleSetSomeBlock('scroll_to_element', '');
				},
				func_error: function (resp) {
					hidePreloader();
					showPopupWithGoBack(resp.message);
					t.setState({go_home_show: true});
				}
			});
		}
	}

	onCancel() {
		this.props.handleSetPayment(true, true, true, false, {}, false);
	}

	onCancelPayment() {
		close_popup();
		this.props.handleSetPayment(true, true, true, true, {}, false);
		window.localStorage.removeItem('start_create_booking');
		window.localStorage.removeItem('end_create_booking');
		if (typeof window.stopBooking === 'function')
			window.stopBooking();
	}

	onPayment(first_check) {
		close_popup();

		window.localStorage.removeItem('start_create_booking');
		window.localStorage.removeItem('end_create_booking');
		if (typeof window.stopBooking === 'function')
			window.stopBooking();

		let t = this;
		let booking_form_data = this.props.booking_form_data;
		let params = {
			action: 'api/booking/payment_windcave',
			ref_id: this.state.ref_id
		};

		this.setState({first_check: first_check});

		AJAX(bm_ajax_url, 'POST', params, {
			response_json: true,
			func_waiting: function () {
				showLoadingPayment();
			},
			func_callback: function (resp) {
				console.log(resp);

				if (!resp.error) {
					hideLoadingPayment();

					if (resp && resp.data) {
						if (t.state.total) {
							try {
								gTagClickEventValue((t.props.booking_form_data.booking.hire === 'local' ? 'click_to_book' : 'click_to_book_interstate'),
									{
										'event_category': 'bookingfinal',
										'event_label': 'booking-final',
										'value': parseInt(t.state.total, 10)
									}
								);
							} catch (e) {
							}
							gTagClickEventValue('click',
								{
									'event_category': 'bookingfinal',
									'event_label': 'booking-final',
									'value': parseInt(t.state.total, 10)
								}
							);

							try {
								gTagClickEventValue('purchase',
									{
										"transaction_id": resp.resno,
										"affiliation": "GWTG Booking",
										"value": parseInt(t.state.total, 10),
										"currency": "AUD",
										"items": [
											{
												"item_id": t.state.hire,
												"item_name": t.state.name,
												"item_category": "App",
												"quantity": 1,
												"price": parseInt(t.state.total, 10)
											}
										]
									}
								);
							} catch (e) {
							}
							gTagClickEventValue('purchase',
								{
									"transaction_id": resp.resno,
									"affiliation": "GWTG Booking",
									"value": parseInt(t.state.total, 10),
									"currency": "AUD",
									"items": [
										{
											"id": t.state.hire,
											"name": t.state.name,
											"category": "App",
											"quantity": 1,
											"price": parseInt(t.state.total, 10)
										}
									]
								}
							);
						}
						t.props.handleSetPayment(false, false, false, false, booking_form_data.payment, true);
					}
				}
				else {
					if (t.state.first_check) {
						setTimeout(t.onPayment, 60000, false);  // if booking not created repeat one time after one minute
						t.setState({first_check: false});
					}
					else {
						hideLoadingPayment();
						t.setState({pressProceed: false});
						t.setState({go_home_show: true});

						if (resp.error === 1) {
							showPopupWithGoBack('<div class="text-center"><b>ERROR CREATING BOOKING.</b><br/>Please contact Go With The Gecko on <a href="tel:1300826883">1300 826 883</a>, let them know you’ve been charged, and they can finalise your booking for you.<br/>Sorry for the inconvenience.</div>');
						} else if (resp.error === 2) {
							showPopupWithGoBack('<div class="text-center">Your credit card has failed when trying to charge for this vehicle hire.The most likely reason being that there is not enough room on the credit card.<br/>Please check the availability of funds, before trying again.<br/>Or call the office on <a href="tel:1300826883">1300 826 883</a>.</div>');
						} else {
							showPopupWithGoBack('<div class="text-center">Sorry! It looks like we have encountered an error securing your reservation. No payment has been taken, but also your reservation hasn’t been made.<br/>Please call our office at <a href="tel:1300826883">1300 826 883</a>, and will get your hire vehicle arranged for you immediately. Thank you.</div>');
						}
					}
				}
			},
			func_error: function (resp) {
				hideLoadingPayment();
				showPopupWithGoBack(resp.message);
				t.setState({go_home_show: true});
			}
		});
	}

	onCheckPayment() {
		if (this.state.duration <= 0) {
			showPopupWithGoBack('<div class="text-center">Sorry! It looks like we have encountered an error securing your reservation. No payment has been taken, but also your reservation hasn’t been made.<br/>Please call our office at <a href="tel:1300826883">1300 826 883</a>, and will get your hire vehicle arranged for you immediately. Thank you.</div>');
			return;
		}

		let t = this;
		let params = {
			action: 'api/booking/payment_check',
			windcave_session_id: this.state.windcave_session_id
		};

		AJAX(bm_ajax_url, 'POST', params, {
			response_json: true,
			func_callback: function (resp) {

				if (!resp.error) {
					let content =
						<div className="row">
							<div className="col-12 text-center" style={{paddingRight: "0", paddingLeft: "0"}}>
								<div className="row m-3">
									<div className="col-12 text-center gray" style={{padding: "0"}}>
										<iframe id={'windcave_3dsecure_iframe'} style={{border: "none"}}
												src={t.state.windcave_3dsecure_link}></iframe>
									</div>
								</div>
								<div className={'row mb-3'}>
									<div className="col-12 text-center">
										<button type="button" className={'btn btn-success'}
												onClick={() => {
													t.onPayment(true)
												}}>Continue creating Booking
										</button>
									</div>
								</div>
							</div>
						</div>;
					show_popup(content, {auto_close: false});
					t.stop_3dSecure();
				}
				else {
					if (resp.timeout || resp.transaction_error) {
						let content =
							<div className="row">
								<div className="col-12 text-center" style={{paddingRight: "0", paddingLeft: "0"}}>
									<div className="row m-3">
										<div className="col-12 text-center gray" style={{padding: "0"}}>
											<iframe id={'windcave_3dsecure_iframe'} style={{border: "none"}}
													src={t.state.windcave_3dsecure_link}></iframe>
										</div>
									</div>
									<div className={'row mb-3'}>
										<div className="col-12 text-center">
											<button type="button" className={'btn btn-secondary'}
													onClick={t.onCancelPayment}>Close
											</button>
										</div>
									</div>
								</div>
							</div>;
						show_popup(content, {auto_close: false});
						t.stop_3dSecure();
						t.setState({go_home_show: true});
						t.setState({pressProceed: false});
					}
					else {
						setTimeout(t.onCheckPayment, 2000, false);  // repeat one time after 2 seconds
					}
				}
			},
			func_error: function (resp) {
				console.log(resp);
				setTimeout(t.onCheckPayment, 2000, false);
			}
		});
	}

	goHomePage() {
		this.props.resetBookingData('');
		close_popup();

		window.localStorage.removeItem('start_create_booking');
		window.localStorage.removeItem('end_create_booking');
		if (typeof window.stopBooking === 'function')
			window.stopBooking();
	}

	render() {
		let current_year = Number(moment().format('YY'));
		let years_list = [];

		for (let i = current_year; i <= (current_year + 20); i++) {
			years_list.push(i);
		}

		let cvn_text = "Card Verification Number (CVN)\n" +
			"A three-digit security number that usually appears on the back of your credit or debit card. Sometimes called a card security code or card verification value, it provides extra protection against fraud.\n" +
			"When asked for your CVN, be sure to enter it properly or your payment might not be successful.\n" +
			"CVNs can appear in different spots on each card. Often, you can find your CVN on the back of your card, near or next to the area where you can add your signature. Some cards show it on the front, near your account number. <br/><br/><img src='../../wp-content/plugins/booking-form/images/security-code.jpg' alt='CVN Examples' className='aligncenter'/>";

		return (<>
			<RedirectOnlyHome />
			<div id={'id_payment_div'} className={'col card-data'} style={{padding: "20px 30px", marginBottom: "25px"}}>
				<h2>Credit Card Information</h2>
				<h4>Hire Charge: {this.props.to_show.total_charges}</h4>
				<h4>Pre-Authorization Amount: {this.props.to_show.pre_authorization}</h4>
				<h4>Total Price: {this.props.to_show.total_all}</h4>
				<div className="row">
					<div className={'form-group col-md-2 fake-placeholder '+((this.state.card_numberDirty && this.state.card_numberError) && 'has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label>Card number</label>
							<span className="star">*</span>
						</div>
						<input className="form-control required"
							   type="text"
							   name="card_number"
							   placeholder={"Card number *"}
							   onChange={this.onChange}
							   onBlur={this.onBlurHandler}
						/>
						{
							(this.state.card_numberDirty && this.state.card_numberError) &&
							<small className="form-control-feedback d-block">{this.state.card_numberError}</small>
						}
					</div>
					<div className={'form-group col-md-2 '+((this.state.expiry_monthDirty && this.state.expiry_monthError) && 'has-danger')}>
						<select className="form-control"
								name="expiry_month"
								id="select_expiry_month"
								onChange={this.onChange}
								onBlur={this.onBlurHandler}>
							<option value="">Expiry month *</option>
							<option value="01">01</option>
							<option value="02">02</option>
							<option value="03">03</option>
							<option value="04">04</option>
							<option value="05">05</option>
							<option value="06">06</option>
							<option value="07">07</option>
							<option value="08">08</option>
							<option value="09">09</option>
							<option value="10">10</option>
							<option value="11">11</option>
							<option value="12">12</option>
						</select>
						{
							(this.state.expiry_monthDirty && this.state.expiry_monthError) &&
							<small className="form-control-feedback d-block">{this.state.expiry_monthError}</small>
						}
						<div id="holder_select_expiry_month" className="select-holder" style={{display: "none"}}>Expiry month <span style={{color:"red"}}>*</span></div>
					</div>
					<div className={'form-group col-md-2 '+((this.state.expiry_yearDirty && this.state.expiry_yearError) && 'has-danger')}>
						<select className="form-control required"
								name="expiry_year"
								id="select_expiry_year"
								onChange={this.onChange}
								onBlur={this.onBlurHandler}>
							<option value="">Expiry year *</option>
							{
								years_list.map((val) => <option key={val} value={val}>{val}</option>)
							}
						</select>
						{
							(this.state.expiry_yearDirty && this.state.expiry_yearError) &&
							<small className="form-control-feedback d-block">{this.state.expiry_yearError}</small>
						}
						<div id="holder_select_expiry_year" className="select-holder" style={{display: "none"}}>Expiry year <span style={{color:"red"}}>*</span></div>
					</div>
					<div className={'form-group col-md-2 fake-placeholder '+((this.state.security_codeDirty && this.state.security_codeError) && 'has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label>Security Code</label>
							<span className="star">*</span>
						</div>
						<input className="form-control required"
							   type="text"
							   name="security_code"
							   placeholder={"Security Code *"}
							   onChange={this.onChange}
							   onBlur={this.onBlurHandler}
							   style={{width: "calc( 100% - 24px)", display: "inline-block"}}
						/>
						<i className="tooltip-info" data-tip data-for="react_tooltip_cvn" style={{marginLeft: "4px", top: "-6px"}}>&nbsp;</i>
						<ReactTooltip
							id="react_tooltip_cvn"
							place="left"
							effect="solid"
							multiline={true}
							className={'react_tooltip'}
							backgroundColor={'black'}
							html={true}
							scrollHide={true}
							isCapture={true}>
							{cvn_text}
						</ReactTooltip>
						{
							(this.state.security_codeDirty && this.state.security_codeError) &&
							<small className="form-control-feedback d-block">{this.state.security_codeError}</small>
						}
					</div>
					<div className={'form-group col-md-2 fake-placeholder '+((this.state.customer_fnameDirty && this.state.customer_fnameError) && 'has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label>Customer first name</label>
							<span className="star">*</span>
						</div>
						<input className="form-control required"
							   type="text"
							   name="customer_fname"
							   placeholder={"Customer first name *"}
							   onChange={this.onChange}
							   onBlur={this.onBlurHandler}
						/>
						{
							(this.state.customer_fnameDirty && this.state.customer_fnameError) &&
							<small className="form-control-feedback d-block">{this.state.customer_fnameError}</small>
						}
					</div>
					<div className={'form-group col-md-2 fake-placeholder '+((this.state.customer_lnameDirty && this.state.customer_lnameError) && 'has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label>Customer last name</label>
							<span className="star">*</span>
						</div>
						<input className="form-control required"
							   type="text"
							   name="customer_lname"
							   placeholder={"Customer last name *"}
							   onChange={this.onChange}
							   onBlur={this.onBlurHandler}
						/>
						{
							(this.state.customer_lnameDirty && this.state.customer_lnameError) &&
							<small className="form-control-feedback d-block">{this.state.customer_lnameError}</small>
						}
					</div>
				</div>
				<div className="row justify-content-center justify-content-md-center">
					<div className="col-auto col-md-auto">
						<input type="button" className="btn btn-success" value="Proceed"  onClick={this.onProceed} disabled={this.state.pressProceed}/>
					</div>
					{
						this.state.go_home_show ?
							(<div className="col-auto col-md-auto">
								<input type="button" className="btn btn-danger" value="Cancel" onClick={this.goHomePage}/>
							</div>)
						:
							(<div className="col-auto col-md-auto">
								<input type="button" className="btn btn-danger" value="Back" onClick={this.onCancel} disabled={this.state.pressProceed}/>
							</div>)
					}
				</div>
			</div>
		</>);
	}
}

export default PaymentPage;
